import React, { useCallback, useState } from 'react';

import { IConsistencyCheckActions } from '@interfaces/cmModule/consistencyCheck';

import AssignConsistencyCheckTemplateMenu from './AssignConsistencyCheckTemplateMenu';
import ChangeMonitoringConsistencyCheckMenu from './ChangeMonitoringConsistencyCheckMenu';

import styles from '../ConsistencyCheckTable.module.scss';

const ConsistencyCheckActions = ({
	currentPageIds,
	selectedIds,
	filter,
}: IConsistencyCheckActions) => {
	const [isAssignMenuVisible, setIsAssignMenuVisible] = useState(false);
	const [isChangeMonitoringMenuVisible, setIsChangeMonitoringMenuVisible] = useState(false);

	const toggleAssignMenuVisibility = useCallback(() => {
		setIsAssignMenuVisible((prev) => !prev);

		if (isChangeMonitoringMenuVisible) {
			setIsChangeMonitoringMenuVisible(false);
		}
	}, [isChangeMonitoringMenuVisible]);

	const toggleChangeMonitoringMenuVisibility = useCallback(() => {
		setIsChangeMonitoringMenuVisible((prev) => !prev);

		if (isAssignMenuVisible) {
			setIsAssignMenuVisible(false);
		}
	}, [isAssignMenuVisible]);

	return (
		<div className={styles.customAction}>
			<AssignConsistencyCheckTemplateMenu
				currentPageIds={currentPageIds}
				filter={filter}
				isVisible={isAssignMenuVisible}
				selectedIds={selectedIds}
				toggleVisibility={toggleAssignMenuVisibility}
			/>
			<ChangeMonitoringConsistencyCheckMenu
				currentPageIds={currentPageIds}
				filter={filter}
				isVisible={isChangeMonitoringMenuVisible}
				selectedIds={selectedIds}
				toggleVisibility={toggleChangeMonitoringMenuVisibility}
			/>
		</div>
	);
};

export default ConsistencyCheckActions;
